import { hasLegacyPlan } from '@gonfalon/constants/constants';
import { enableMarketplaceBilling } from '@gonfalon/dogfood-flags/dogfood-flags';
import { MarketplaceProviders, SubscriptionTypes } from '@gonfalon/openapi/types';
import { getSubscriptionQuery } from '@gonfalon/rest-api/queries/billing';
import { useOptionalProjectKey } from '@gonfalon/router/useOptionalProjectKey';
import { useQuery } from '@tanstack/react-query';

import { VERCEL_ENV_KEYS } from './internal/constants';

export function useIsVercelEnv(envKey: string, projectKey?: string): boolean {
  const accountHasLegacyPlan = hasLegacyPlan() ?? false;
  const urlProjectKey = useOptionalProjectKey();
  const effectiveProjectKey = projectKey ?? urlProjectKey;
  const { data: subscription } = useQuery({
    ...getSubscriptionQuery(),
    enabled: !accountHasLegacyPlan && enableMarketplaceBilling(),
  });

  if (!enableMarketplaceBilling() || accountHasLegacyPlan || !subscription || effectiveProjectKey === 'default') {
    return false;
  }

  return (
    (VERCEL_ENV_KEYS as readonly string[]).includes(envKey) &&
    subscription.subscriptionType === SubscriptionTypes.MARKETPLACE &&
    subscription.marketplaceProvider === MarketplaceProviders.VERCEL
  );
}
